import { Stack } from '@mui/material';
import React from 'react';
import Page from '../../../../components/Page';
import { DataGrid } from '@mui/x-data-grid';
import CustomGridToolbar from '../../../../components/datagrid/GridToolBar';
import { Box, Paper, TextField, MenuItem, FormControl, InputLabel, Select } from '@mui/material';
import { useState } from 'react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { clearStates, createTableHead, getAllAttendance } from '../../../../redux/features/attendanceSlice';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { getPreData } from '../../../../redux/features/userSlice';

import MarkAttendanceStyle from '../../../../components/datagrid/MarkAttendanceStyle';
import {
  END_PORTION_TABLE_HEAD,
  START_PORTION_TABLE_HEAD,
} from '../../../../components/datagrid/Attendance/AllAttendanceTableHead';
import Loader from '../../../../components/Loader/Loader';
import Wrapper from '../../../../components/Wrapper/Wrapper';
import useResponsive from '../../../../Hooks/useResponsive';
import dayjs from 'dayjs';
import GlobalSelectFieldWithoutFormikNew from '../../../../components/mui/GlobalSelectFieldWithoutFormikNew';
import useHandleApiResponse from '../../../../Hooks/useHandleApiResponse';
import EditEmployeeAttendance from '../../../../components/datagrid/Attendance/EditEmployeeAttendance';

export default function AllAttendance() {
  const smUp = useResponsive('up', 'sm');

  const mdUp = useResponsive('up', 'md');
  const attendances = useSelector((state) => state.attendance);
  const [gridSize, setGridSize] = useState(50);
  const [tableHead, setTableHead] = useState([]);
  const dispatch = useDispatch();
  const [value, setValue] = React.useState('');
  const [department, setDepartment] = React.useState(0);
  let { preData } = useSelector((state) => state.users);
  const [date, setDate] = React.useState(dayjs().format('YYYY-MM'));
  const [verificationType, setVerificationType] = useState({ id: -1, value: '' });
  const [refresh, setRefresh] = useState(false);
  const apiHandleHelper = useHandleApiResponse();

  // ----------------------useEffect-------------------------------
  useEffect(() => {
    dispatch(createTableHead(date));
    dispatch(getPreData());
  }, []);

  /*   useEffect(() => {
    let newValue = new Date();
    setValue(newValue);
    setDepartment(0);
    const yer = `${newValue.toISOString().split('T')[0].split('-')[0]}/${
      newValue.toISOString().split('T')[0].split('-')[1]
    }`;

    setDate(yer);

    dispatch(createTableHead(yer));
    const data = { date: yer, dep: 0, verification: verificationType.id === -1 ? null : verificationType.id };
    dispatch(getAllAttendance(data));
    return () => dispatch(clearStates());
  }, []); */

  useEffect(() => {
    const table = attendances.tableHead.map((item, i) => {
      if (item.day) {
        item = {
          ...item,
          renderCell: (params) => MarkAttendanceStyle(params),
        };
      }
      return item;
    });

    const END_PORTION_TABLE_HEAD_DATA = END_PORTION_TABLE_HEAD({ setRefresh, apiHandleHelper, dispatch });

    setTableHead([
      ...START_PORTION_TABLE_HEAD,
      ...table,
      ...END_PORTION_TABLE_HEAD_DATA,
      {
        field: 'Edit',
        minWidth: 150,
        headerName: 'Edit',
        renderCell: (params) => {
          const formattedMonth = dayjs(date).format('MM');
          const formattedYear = dayjs(date).format('YYYY');
          const yearMonth = {
            month: formattedMonth,
            year: formattedYear,
          };
          const param = { ...params.row, ...yearMonth, hr_all: true };

          return EditEmployeeAttendance(param);
        },
      },
    ]);
  }, [attendances.tableHead, setRefresh, dispatch]);

  // ------------------------onChange---------------------------------------

  const handleChange = (newValue) => {
    const localDate = newValue.format('YYYY-MM');
    dispatch(createTableHead(localDate));
    setDate(localDate);
  };

  const handleDepChange = (e) => {
    setDepartment(e.target.value);
  };
  useEffect(() => {
    const data = {
      date: date?.replace?.('-', '/'),
      dep: department,
      verification: verificationType.id === -1 ? null : verificationType.id,
    };
    dispatch(getAllAttendance(data));
  }, [verificationType, dispatch, date, department, refresh]);

  // -------------------------------------------------------------------------
  return (
    <div>
      <Wrapper
        title="All Attendance"
        Content={
          <Page>
            {attendances.loading ? (
              <Loader />
            ) : (
              <>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: smUp ? 'flex-end' : 'center',
                  }}
                >
                  <Box sx={{ padding: 2 }}>
                    <Stack direction={smUp ? 'row' : 'column'} spacing={2}>
                      <Box>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            views={['year', 'month']}
                            label="Year and Month"
                            inputFormat="YYYY/MM"
                            disableFuture
                            value={dayjs(date)}
                            onChange={handleChange}
                            renderInput={(params) => (
                              <TextField fullWidth {...params} helperText={null} variant="filled" />
                            )}
                          />
                        </LocalizationProvider>
                      </Box>
                      <Box
                        sx={{
                          width: 220,
                          marginLeft: 2,
                        }}
                      >
                        <FormControl fullWidth>
                          <InputLabel id="demo-simple-select-label">Select Department</InputLabel>
                          <Select
                            name="deptId"
                            value={department}
                            label="Department"
                            variant="filled"
                            fullWidth
                            onChange={handleDepChange}
                          >
                            <MenuItem value={0}>All</MenuItem>,
                            {preData.departments?.map((item) => {
                              return (
                                <MenuItem key={item.departmentName} value={item.departmentId}>
                                  {item.departmentName}
                                </MenuItem>
                              );
                            })}
                          </Select>
                        </FormControl>
                      </Box>
                      <GlobalSelectFieldWithoutFormikNew
                        data={[
                          { id: -1, name: 'All' },
                          { id: 0, name: 'Non Verified' },
                          { id: 1, name: 'All Verified' },
                          { id: 2, name: 'Self Verified' },
                          { id: 3, name: 'Hr Verified' },
                        ]}
                        keys={{
                          itemId: 'id',
                          itemValue: 'name',
                        }}
                        selectedDetails={verificationType}
                        setChange={setVerificationType}
                        label={'Type'}
                        sx={{ minWidth: 220 }}
                      />
                    </Stack>
                  </Box>
                </Box>
                <Paper
                  elevation={3}
                  sx={{
                    borderRadius: 1,
                    width: '100%',
                    marginTop: 1,
                  }}
                >
                  <Box sx={{ width: '100%' }}>
                    <DataGrid
                      loading={attendances.loading}
                      rows={attendances.data}
                      columns={tableHead}
                      sx={{
                        borderTopLeftRadius: 0,
                        borderTopRightRadius: 0,
                      }}
                      pageSize={gridSize}
                      onPageSizeChange={(newGridSize) => setGridSize(newGridSize)}
                      autoHeight
                      rowsPerPageOptions={[5, 10, 25, 50]}
                      getRowId={(row) => row.userId}
                      components={{
                        Toolbar: CustomGridToolbar,
                      }}
                      componentsProps={{
                        toolbar: {
                          showQuickFilter: true,
                          quickFilterProps: {
                            debounceMs: 500,
                          },
                        },
                      }}
                    />
                  </Box>
                </Paper>
              </>
            )}
          </Page>
        }
      />
    </div>
  );
}
